import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Mui
import { Box, Stack, Typography } from "@mui/material";

// Local
import CustomCard from "../../components/UI/Cards/CustomCard";
import OtpInputs from "../../components/UI/Form/OtpInputs";
import PrimaryButton from "../../components/UI/Buttons/PrimaryButton";
import { authActions } from "../../store/state-slices/auth";
import {
  Text,
  Container,
  Button,
  InputCode,
  Spinner,
  Notifications,
  ActionButton,
} from "@jds/core";
import useInput from "../../hooks/use-input";
import { validatePassword } from "../../util/validation";
import useApiHttp from "../../hooks/use-http";
import FormErrorLabel from "../../components/UI/FormErrorLabel/FormErrorLabel";

export default function Otp(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { phoneNumber, countryCode, identifier } = location.state;
  const [resendOTPIdentifier, setResendOTPIdentifier] = useState(identifier);
  const {
    value: otp,
    isValid: isValidOtp,
    hasError: otpError,
    valueChangeHandler: otpChangeHandler,
    inputBlurHandler: otpBlurHandler,
    reset: resetOtp,
  } = useInput(validatePassword);
  const { sendRequest: verifyUserOtp, isLoading } = useApiHttp();
  const { sendRequest: resendOtp, isLoading: resendOTPLoading } = useApiHttp();

  const isValidForm = !isValidOtp;
  const handleSubmit = (e) => {
    // e.preventDefault();
    verifyUserOtp(
      {
        base: "AUTH",
        isBearer: false,
        url: `user/verify-web-otp`,
        method: "POST",
        // body: {
        //   identifier: identifier || `${countryCode}${phoneNumber}`,
        //   otp,
        // },
        body: {
          countryCode: countryCode,
          phoneNumber: phoneNumber,
          identifier: identifier || null,
          otp: otp,
        },
      },
      null,
      (data) => {
        navigate("/home");
        localStorage.authToken = data.data.accessToken;
        localStorage.refreshToken = data.data.refreshToken;
        Notifications.toast.success({ id: "verify-otp", title: data?.message });
      },
      (_, data) => {
        Notifications.toast.error({ id: "verify-otp", title: data?.message });
      }
    );
  };

  const resendOTPHandler = () => {
    resendOtp(
      {
        base: "AUTH",
        isBearer: false,
        url: `user/web-login`,
        method: "POST",
        body: {
          countryCode,
          phoneNumber,
        },
      },
      null,
      (data) => {
        setResendOTPIdentifier(data?.data?.identifier);
        Notifications.toast.success({
          id: "resend-otp",
          title: "OTP resent successfully",
        });
      },
      (err, data) => {
        Notifications.toast.success({ id: "resend-otp", title: data?.message });
      }
    );
  };
  return (
    <CustomCard
      sx={{
        padding: "32px",
        maxWidth: "484px",
        minWidth: "484px",
        minHeight: "585px",
        "@media screen and (max-width: 1024px)": {
          minWidth: "unset",
        },
      }}
    >
      <div>
        <Container direction="column" fullWidth style={{ justifyContent: "" }}>
          <Container direction="column" gap={16} fullWidth>
            <Text appearance="heading-xs">Verify your mobile number</Text>
            <Container direction="column" gap={0} className="">
              <Text appearance="body-s">Enter the OTP sent to </Text>
              <Container direction="row" gap={5}>
                <Text appearance="body-s">
                  {`${countryCode}${phoneNumber}`}.
                </Text>
                <Link to={"/auth/signin"}>
                  <Text appearance="body-s-link">Change number</Text>
                </Link>
              </Container>
            </Container>
          </Container>
          <Container
            direction="column"
            fullWidth
            style={{ margin: "48px 0 24px 0" }}
          >
            <div
              onKeyDown={(e) => {
                if (e.key == "Enter") handleSubmit();
              }}
            >
              <InputCode
                name="otp"
                value={otp}
                onChange={(e) => {
                  otpChangeHandler(e);
                }}
                onBlur={otpBlurHandler}
                stateText="invalid otp"
                state={otpError ? "error" : ""}
                codeLength={6}
              />
            </div>

            {/* <InputCode codeLength={6} /> */}
          </Container>

          <Container horizontalAlign="end" fullWidth>
            <Button
              type="button"
              kind="tertiary"
              label="Resend OTP"
              loading={resendOTPLoading}
              onClick={resendOTPHandler}
            />
          </Container>

          <Container
            direction="row"
            fullWidth
            style={{ justifyContent: "flex-end" }}
          >
            {/* <Text appearance="body-s-link">Resend OTP</Text> */}
          </Container>
          <Container style={{ marginTop: "213px" }} fullWidth>
            <Button
              onClick={handleSubmit}
              fullWidth
              disabled={isValidForm}
              size="large"
              kind={isLoading ? "secondary" : "primary"}
            >
              {isLoading ? (
                <Spinner kind="vibrant" label="Loading..." size="small" />
              ) : (
                "Verify"
              )}
            </Button>
          </Container>
        </Container>
      </div>
    </CustomCard>
  );
}
